'use client'

import type { StaticImageData } from 'next/image'

import React from 'react'
import { Box, Container, styled } from '@mui/material'
import RichText from '@/components/RichText'

import type { MediaBlock as MediaBlockProps } from '@/payload-types'

import { Media } from '@/components/Media'

type Props = MediaBlockProps & {
  breakout?: boolean
  captionClassName?: string
  className?: string
  enableGutter?: boolean
  imgClassName?: string
  staticImage?: StaticImageData
  disableInnerContainer?: boolean
  blockName?:string
}

const StyledMediaWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider || '#e0e0e0'}`,
  borderRadius: '0.8rem',
  overflow: 'hidden',
  '& img': {
    display: 'block',
    width: '100%',
    height: 'auto',
  },
}))

export const MediaBlock: React.FC<Props> = (props) => {
  const {
    captionClassName,
    className,
    enableGutter = true,
    imgClassName,
    media,
    staticImage,
    disableInnerContainer,
    blockName: _blockName,
  } = props

  let caption
  if (media && typeof media === 'object' && 'caption' in media) {
    caption = (media as any).caption
  }

  const content = (
    <>
      {(media || staticImage) && (
        <StyledMediaWrapper className={imgClassName}>
          <Media
            resource={media}
            src={staticImage}
          />
        </StyledMediaWrapper>
      )}
      {caption && (
        <Box
          sx={{
            mt: 3,
          }}
          className={captionClassName}
        >
          {!disableInnerContainer ? (
            <Container>
              <RichText data={caption} enableGutter={false} />
            </Container>
          ) : (
            <RichText data={caption} enableGutter={false} />
          )}
        </Box>
      )}
    </>
  )

  if (enableGutter) {
    return (
      <Container  className={className}>
        {content}
      </Container>
    )
  }

  return (
    <Box  className={className}>
      {content}
    </Box>
  )
}
